
import axios from 'axios';
import history from '../containers/App/History';

const REQUEST = async (config) => {
    const token = localStorage.getItem('easydev');
    const HTTP = axios.create({
        baseURL: (process.env.REACT_APP_API_URL + process.env.REACT_APP_API_Connector) || '',
    });
    await HTTP.interceptors.request.use((request) => {
        if (config.auth) {
            request.headers = { Authorization: token };
        }
        request.url = request.baseURL + config.url;
        request.data = config.data;
        request.method = config.method;

        return request;
    });

    HTTP.interceptors.response.use(
        (response) => {
            if(response.status === 200) {
                return response?.data;
            }
            if (response.status === 403) {
                history.push('/login');
                return null;
            } 
            if(response.status !== 200) {
                console.log("Invalid User, Please try again!")
                return null
            }

            return null;
        },
        (error) => {
            console.error('error', error);
            if (error?.response?.status === 403) {
                history.push('/login');
                return null;
            } 
            if(error?.response?.status !== 200) {
                console.log("Invalid User, Please try again!")
                return null
            }

            return error?.response;
        }
    );
    return HTTP();
};
export default REQUEST;

